module.exports = __webpack_public_path__ + "img/Smart-Cities-and-Communities.93d5d91c.png";